<template>

  <div>
    <store-header :showDoc="true"></store-header>
    <div class="app-wrapper">
      <div class="container">
        <div class="container-inner">
        <el-col :span="12">
          <img :src="img_404" alt="404" class="img-style" />
        </el-col>
        <el-col :span="12">
          <div style="margin-left: 100px;margin-top: 60px">
            <h1 class="color-main">OOPS!</h1>
            <h2 style="color: #606266">很抱歉，页面它不小心迷路了！</h2>
            <div style="color:#909399;font-size: 14px">请检查您输入的网址是否正确，请点击以下按钮返回主页或者发送错误报告</div>
            <el-button style="margin-top: 20px" type="primary" round @click="handleGoMain">返回首页</el-button>
          </div>
        </el-col>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import img_404 from '@/assets/images/gif_404.gif';

export default {
  name: 'WrongPage',
  data() {
    return {
      img_404
    };
  },
  methods: {
    handleGoMain() {
      this.$router.push({ name: 'index' });
    }
  }
};
</script>

<style>
.container {
  width: 1200px;
  margin: 0 auto;
}
.container-inner {
  margin-top: 180px;
}
.img-style {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/404.vue